// extracted by mini-css-extract-plugin
export default {"base":"DialogActions_base__SNV9p"};